import { jsx as a, jsxs as g } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import * as e from "@radix-ui/react-accordion";
import { twMerge as c } from "tailwind-merge";
const n = i(
  ({ children: o, className: r, ...t }, p) => /* @__PURE__ */ a(
    e.Root,
    {
      className: c("flex flex-col gap-4", r),
      ref: p,
      ...t,
      children: o
    }
  )
);
n.displayName = e.Root.displayName;
const d = i(
  ({ className: o, ...r }, t) => /* @__PURE__ */ a(
    e.Item,
    {
      ref: t,
      className: c(
        "group/accordion-item rounded-xl border border-solid border-gray-200 bg-white shadow-sm",
        o
      ),
      ...r
    }
  )
);
d.displayName = e.Item.displayName;
const s = i(
  ({ className: o, ...r }, t) => /* @__PURE__ */ g(
    "div",
    {
      className: c(
        "relative size-4 text-black",
        "group-radix-disabled/accordion-item:text-gray-500",
        o
      ),
      ref: t,
      ...r,
      children: [
        /* @__PURE__ */ a("span", { className: "group-radix-state-open/accordion-item:rotate-90 absolute right-0 top-0 block h-4 w-0.5 bg-current transition" }),
        /* @__PURE__ */ a("span", { className: "absolute right-0 top-0 block h-4 w-0.5 rotate-90 bg-current" })
      ]
    }
  )
);
s.displayName = "AccordionItemIndicator";
const m = i(
  ({ className: o, ...r }, t) => /* @__PURE__ */ a(
    e.Trigger,
    {
      ref: t,
      className: c(
        "flex w-full items-center justify-between gap-4 px-6 py-4 text-lg font-medium text-gray-900",
        "group-radix-disabled/accordion-item:text-gray-500 group-radix-disabled/accordion-item:cursor-not-allowed",
        o
      ),
      ...r
    }
  )
);
m.displayName = e.Trigger.displayName;
const l = i(
  ({ className: o, ...r }, t) => /* @__PURE__ */ a(
    e.Content,
    {
      ref: t,
      className: c(
        "radix-state-open:animate-accordionDown radix-state-closed:animate-accordionUp overflow-hidden",
        o
      ),
      ...r
    }
  )
);
l.displayName = e.Content.displayName;
const N = n, b = d, y = s, w = e.Header, I = m, h = l, A = e.Header;
export {
  l as AccordionContent,
  A as AccordionHeader,
  d as AccordionItem,
  s as AccordionItemIndicator,
  n as AccordionRoot,
  m as AccordionTrigger,
  h as Content,
  w as Header,
  b as Item,
  y as ItemIndicator,
  N as Root,
  I as Trigger
};
